import gsap, {Linear} from 'gsap';
import { ScrollToPlugin } from "gsap/all";
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {throttle} from 'throttle-debounce';

import initScrollTrigger from '../helpers/initScrollTrigger';
import сustomPageScroll from './custom-scroll';
import { Gradient } from '../helpers/gradient';

import { CLASSES, isHomePage, IS_HOME_VERTICAL } from "../helpers/consts";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

const blueColor = 'is-blue';
// modal-brown-white
const mainColor = 'is-main-color';
const pinkColor = 'is-pink';
const globalPinkColor = 'is-global-pink-color';
const whiteColor = 'is-white';
const blueLColor = 'is-blue-l';
const logoSidePinkColor = 'is-logo-side-pink';
const menuSidePinkColor = 'is-menu-side-pink';


const header = document.querySelector('.js-header');
const menuBtn = header.querySelector('.js-menu-btn');
const logoLink = header.querySelector('.js-header-logo-link');


const removeAllColors = () => {
	header.classList.remove(blueColor);
	header.classList.remove(mainColor);
	header.classList.remove(pinkColor);
	header.classList.remove(whiteColor);
	header.classList.remove(blueLColor);
	header.classList.remove(logoSidePinkColor);
	header.classList.remove(menuSidePinkColor);
	header.classList.remove(globalPinkColor);
}

const getClosestPrevElement = (element, array) => {
	// Получаем индекс текущего элемента в массиве
	let index = array.indexOf(element);

	// Если элемент не найден в массиве, вернем null
	if(index === -1) return null;

	// Перебираем предыдущие элементы в массиве
	for(let i = index - 1; i >= 0; i--) {
			// Если data-inner не равно "true", возвращаем этот элемент
			if(array[i].getAttribute('data-inner-color') !== 'true') {
					return array[i];
			}
	}

	// Если подходящего элемента не найдено, вернем null
	return null;
}


const initHomeHeaderColors = () => {
	const container = document.querySelector('.js-cards-section');

	const updateFunc = throttle(20, () => {
		const containerRect = container.getBoundingClientRect();
		const menuRect = menuBtn.getBoundingClientRect();
		const halfMenuBtnWidht = menuRect.width / 2;
		const logoRect = logoLink.getBoundingClientRect();
		const halfLogoLinkWidht = logoRect.width / 2;

		if(menuRect.right - halfMenuBtnWidht < containerRect.right) {
			header.classList.remove(menuSidePinkColor);
		} else {
			header.classList.add(menuSidePinkColor);
		}

		if(logoRect.right - halfLogoLinkWidht < containerRect.right) {
			header.classList.remove(logoSidePinkColor);
		} else {
			header.classList.add(logoSidePinkColor);
		}
	})

	ScrollTrigger.create({
		trigger: container,
		horizontal: true,
		start: () => {
			const ww = window.innerWidth;
			return `left+=${ww/2}px left`
		},
		end: () => {
			const ww = window.innerWidth;
			return `right+=${ww}px right`
		},

		onEnter: () => {
		},
		onEnterBack: () => {
			console.log(`onEnterBack`)
			header.classList.add(blueColor);
			header.classList.add(logoSidePinkColor);
			header.classList.add(menuSidePinkColor);
		},
		onUpdate: updateFunc,
	});



	// vertical scroll
	const verticalContainer = document.querySelector('.js-home-anim-container');
	const verticalSections = verticalContainer.querySelectorAll('.js-header-color-section');

	const verticalUpdateFunc = throttle(50, () => {
		const headerH = header.offsetHeight - 20;
		let isMarqueesSection = true;

		for (let section of verticalSections) {
			const rect = section.getBoundingClientRect();
			if (rect.top <= headerH && rect.top + rect.height > headerH) {
				const sectionColor = section.dataset.color;
				removeAllColors();
				header.classList.add(sectionColor);
				isMarqueesSection = false

				break;
			}
		}

		if (isMarqueesSection) {
			removeAllColors();
			header.classList.add(blueColor);
			header.classList.add(logoSidePinkColor);
			header.classList.add(menuSidePinkColor);
		}
	})

		ScrollTrigger.create({
			trigger: verticalContainer,
			horizontal: true,
			start: 'left left',
			end: 'right right',
			onUpdate: verticalUpdateFunc,
		});
};


const initHeaderColors = () => {
	initScrollTrigger();

	if(isHomePage && !IS_HOME_VERTICAL) {
		initHomeHeaderColors();
		return;
	}


	let colorSections = [];

	if(!IS_HOME_VERTICAL) {
		colorSections = [...document.querySelectorAll('.js-header-color-section')];
	} else {
		colorSections = [...document.querySelectorAll('.js-header-color-section, .js-header-color-section-vertical')];
	}
	colorSections.forEach((section, index) => {
		const sectionColor = section.dataset.color;
		const prevSection = index > 0 ?  colorSections[index - 1] : null;
		const prevSectionColor = prevSection ? prevSection.dataset.color : null;
		let wrapperSectionColor = null;
		const isInnerColorSection = section.dataset.innerColor === 'true';
		// const wrapperSection = section.parentElement.closest('.js-header-color-section');
		const wrapperSection = getClosestPrevElement(section, colorSections);
		if(isInnerColorSection && wrapperSection) {
			wrapperSectionColor = wrapperSection.dataset.color;
		}

		const trigger = ScrollTrigger.create({
			trigger: section,
			start: () => {
				const headerH = header.offsetHeight - 20;
				return `0px ${headerH}px`
			},

			end: () => {
				return `+=${section.offsetHeight  + 20}px`
			},
			onEnter: () => {
				removeAllColors();
				header.classList.add(sectionColor);
			},
			onLeaveBack: () => {
				removeAllColors();
				if(isInnerColorSection) {
					if(wrapperSectionColor) header.classList.add(wrapperSectionColor);
				} else {
					const prevSection = getClosestPrevElement(section, colorSections);
					const color = prevSection ? prevSection.dataset.color : null;
					if(color) header.classList.add(color);
				}
			},

			onLeave: () => {
				if(isInnerColorSection) {
					removeAllColors();
					if(wrapperSectionColor) header.classList.add(wrapperSectionColor);
				}
			},
			onEnterBack: () => {
				if(isInnerColorSection) {
					removeAllColors();
					header.classList.add(sectionColor);
				}
			},
		});
	});

}
export default () => {
	const openMenuBtn = header.querySelector('.js-menu-btn');
	const closeBtn = header.querySelector('.js-header-close-btn');

	const gradient = new Gradient();
	gradient.initGradient('#menu-gradient-canvas');
	gradient.pause();

	openMenuBtn.addEventListener('click', (e) => {
		e.preventDefault();
		gradient.play();
		document.body.classList.add(CLASSES.menuOpen);
	});
	closeBtn.addEventListener('click', (e) => {
		e.preventDefault();
		document.body.classList.remove(CLASSES.menuOpen);
		gradient.pause();
	});

	initHeaderColors(header);
};
